import ControleSessao from '../../componentes-padrao/ControleSessao';

export function configureMovideskChat() {
    if (process.env.ENVIRONMENT_WHITE_LABEL != "LOGAE") {
        return;
    }

    // Usuários sem o parâmetro "Visualiza chat Movidesk" não carregam o widget,
    // impedindo o acesso ao chat em vez de apenas ocultar o ícone.
    if (!ControleSessao.getVisualizaChatMovidesk()) {
        return;
    }

    var scriptChat = document.createElement("script");
    scriptChat.src = "https://chat.movidesk.com/Scripts/chat-widget.min.js";
    document.body.appendChild(scriptChat);
}
